import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OvertimeStatuses } from 'shared/enums/overtime';
import { TOvertime } from 'shared/types/overtime.types';
import { TDivisionEmployees } from 'shared/types/types';

const initialState: TOvertime = {
  id: 0,
  created: '',
  count: 0,
  status: OvertimeStatuses.NOT_LOADED_CPRODUCT,
  employees: [],
  docSignatory: '',
};

export const overtimeSlice = createSlice({
  name: 'overtime',
  initialState,
  reducers: {
    setCurrent: (state, { payload }: PayloadAction<TOvertime>) => payload,
    clearCurrent: () => initialState,
  },
});

export const overtimeActions = overtimeSlice.actions;
export const reducer = overtimeSlice.reducer;
